import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MailCheck, Loader2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { http } from "@/lib/api";
import logoMark from "@/assets/logo-mark.png";

// Lote 144 — "Esqueci minha senha": pede o e-mail e manda um link (1 hora, uso único). A resposta é
// sempre a mesma, exista ou não a conta, para não revelar quem tem cadastro.
export default function EsqueciSenha() {
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || "");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const enviar = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await http.post("/auth/esqueci-senha", { email });
      setDone(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Não foi possível enviar agora. Tente de novo em instantes.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-center px-6 py-16 bg-white">
      <div className="w-full max-w-sm mx-auto space-y-8">
        <div className="flex items-center gap-2">
          <img src={logoMark} alt="" className="w-9 h-9 rounded-md" />
          <span className="font-display text-xl font-bold"><span className="text-gold-600">IA</span>pauta</span>
        </div>

        {done ? (
          <div className="text-center space-y-4 py-6" data-testid="esqueci-enviado">
            <div className="w-14 h-14 rounded-full bg-gold-500/15 border border-gold-500/25 flex items-center justify-center mx-auto">
              <MailCheck className="w-7 h-7 text-gold-700" strokeWidth={1.75} />
            </div>
            <h2 className="font-display text-2xl font-bold text-stone-900">Confira seu e-mail</h2>
            <p className="text-sm text-stone-500 leading-relaxed">
              Se <strong>{email}</strong> tiver cadastro, enviamos um link para criar uma nova senha.
              Ele vale por 1 hora e só funciona uma vez. Olhe também a caixa de spam.
            </p>
            <p className="text-xs text-stone-400 leading-relaxed">
              Não chegou? Peça ao administrador do seu escritório para gerar um link pra você.
            </p>
            <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-emerald-brand font-medium hover:underline pt-2">
              <ArrowLeft className="w-3.5 h-3.5" strokeWidth={2} /> Voltar para o login
            </Link>
          </div>
        ) : (
          <>
            <div>
              <h2 className="font-display text-3xl font-bold text-stone-900 mb-2">Esqueci minha senha</h2>
              <p className="text-sm text-stone-500 leading-relaxed">
                Digite o e-mail da sua conta. Enviamos um link para você criar uma nova senha.
              </p>
            </div>
            <form onSubmit={enviar} className="space-y-4">
              <div className="space-y-1.5">
                <Label htmlFor="esqueci-email">E-mail</Label>
                <Input
                  id="esqueci-email" data-testid="esqueci-email-input" type="email" autoComplete="email" required
                  value={email} onChange={(e) => setEmail(e.target.value)} placeholder="voce@escritorio.com.br"
                />
              </div>
              <Button data-testid="esqueci-enviar" type="submit" disabled={submitting} className="w-full h-11 bg-emerald-brand text-white font-medium rounded-md">
                {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : "Enviar link"}
              </Button>
            </form>
            <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-stone-500 hover:text-stone-800">
              <ArrowLeft className="w-3.5 h-3.5" strokeWidth={2} /> Voltar para o login
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
